import React, { useState, useEffect, useRef } from 'react';
const MegaMenuSearch = ({ searchPageUrl, isSearchOpen }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const inputRef = useRef(null);
    useEffect(() => {
        if (isSearchOpen) {
            inputRef.current?.focus();
        }
    }, [isSearchOpen]);
    const handleSearch = (evt) => {
        evt.preventDefault();
        if (!searchPageUrl) {
            console.log('search page is not set');
            return;
        }
        const searchUrl = new URL(searchPageUrl);
        searchUrl.searchParams.set('q', searchQuery);
        window.location.assign(searchUrl.toString());
    };
    const handleSearchClear = () => {
        setSearchQuery('');
    };
    return (React.createElement("form", { className: "mega-menu__search-form", onSubmit: e => handleSearch(e) },
        React.createElement("div", { className: "mega-menu__search" },
            React.createElement("input", { ref: inputRef, value: searchQuery, type: "text", placeholder: "Search", className: "mega-menu__search-input", onChange: e => setSearchQuery(e.target.value) }),
            searchQuery !== '' &&
                React.createElement("button", { type: "button", onClick: handleSearchClear },
                    React.createElement("svg", { role: "presentation", className: "mega-menu__search-icon mega-menu__search-icon--clear" },
                        React.createElement("use", { xlinkHref: "#close" }))),
            React.createElement("button", { type: "submit" },
                React.createElement("svg", { role: "presentation", className: "mega-menu__search-icon" },
                    React.createElement("use", { xlinkHref: "#search-icon" }))))));
};
export default MegaMenuSearch;
